module.exports = {
  client_key: "dlc",
  user: {
    id: 1,
    token: "thisIsASampleToken",
    name_vch: "Sample User",
    email_vch: "sample@email.com",
    active_int: 1,
    created_dt: new Date().toJSON(),
    updated_dt: new Date().toJSON(),
  },
};
